import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SportsTitleCasePipe } from "@sports-pipes/index";

@Component({
  selector: "sb-live-scoreboard-baseball",
  templateUrl: "./sb-live-scoreboard-baseball.html",
  styleUrls: ["./sb-live-scoreboard-baseball.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, SportsTitleCasePipe],
})
export class SbLiveScoreboardBaseballComponent {
  @Input() match: any;
  sport: string;
  bases: [false, false, false];
  quarter: any = 0;
  currentPeriod: number;
  MAX_INNINGS = 9;

  ngOnChanges() {
    this.sport = this.match.SportHandle;
    this.quarter = this.match.Quarters;
    this.fillInnings();
    this.bases = [this.match?.Bases?.Basethree, this.match?.Bases?.Basetwo, this.match?.Bases?.Baseone];
  }

  private fillInnings() {
    if (this.match.Innings.length < this.MAX_INNINGS) {
      this.currentPeriod = this.match.Innings.length;
      const blank = ["-", "-"];
      let fill = this.MAX_INNINGS - this.currentPeriod;
      const newInnings = [...this.match.Innings];
      while (fill > 0) {
        newInnings.push(blank);
        fill--;
      }
      this.match = {
        ...this.match,
        Innings: newInnings,
      };
    }
  }

  //!no needed?
  get service(): boolean {
    return (
      this.sport === "badminton" ||
      this.sport === "tennis" ||
      this.sport === "table_tennis" ||
      this.sport === "tennis_clay" ||
      this.sport === "tennis_grass" ||
      this.sport === "tennis_indoor" ||
      this.sport === "beach_volleyball" ||
      this.sport === "volleyball"
    );
  }
}
